import React from "react";

const Categories = () => {
  return (
    <>
      <div className="container">
        <ul className="catag">
          <li>
            <a href="/"> Home</a>
          </li>
          <li>
            <a href="/section?categories=technology">Technology</a>
          </li>
          <li>
            <a href="/section?categories=world">World</a>
          </li>
          <li>
            <a href="/section?categories=us">US</a>
          </li>
          <li>
            <a href="/section?categories=arts">Arts</a>
          </li>
          <li>
            <a href="/section?categories=automobiles">Automobiles</a>
          </li>
          <li>
            <a href="/section?categories=business">Business</a>
          </li>
          <li>
            <a href="/section?categories=fashion">Fashion</a>
          </li>
          <li>
            <a href="/section?categories=health">Health</a>
          </li>
          <li>
            <a href="/section?categories=politics">Politics</a>
          </li>
          <li>
            <a href="/section?categories=sports">Sports</a>
          </li>
          <li>
            <a href="/section?categories=movies">Movies</a>
          </li>
          <li>
            <a href="/section?categories=science">Science</a>
          </li>
          <li>
            <a href="/section?categories=sports">Sports</a>
          </li>
          <li>
            <a href="/section?categories=travel">Travel</a>
          </li>
          <li>
            <a href="/section?categories=books">Books</a>
          </li>
          <li>
            <a href="/section?categories=insider">Insider</a>
          </li>
          <li>
            <a href="/section?categories=opinion">Opinion</a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Categories;
